type Environment =
  | 'test'
  | 'testing'
  | 'development'
  | 'staging'
  | 'sandbox'
  | 'production';

type DashboardQueryConfig = {
  environment: Environment;
  loggingEnabled: boolean;
};

type DashboardQueryContext = {
  config: DashboardQueryConfig;
  initialized?: boolean;
};

const defaultContext: DashboardQueryContext = {
  config: {
    environment: 'development',
    loggingEnabled: false,
  },
  initialized: false,
};

Object.freeze(defaultContext);
Object.freeze(defaultContext.config);

export let DashboardQueryContext = defaultContext;

export const initDashboardQueryContext = (
  config?: Partial<DashboardQueryContext['config']>,
) => {
  DashboardQueryContext = {
    config: {
      ...defaultContext.config,
      ...config,
    },
    initialized: true,
  };

  Object.freeze(DashboardQueryContext);
  Object.freeze(DashboardQueryContext.config);
  return DashboardQueryContext;
};
